// `site.year` is resolved when Eleventy builds, not when the page is served, and
// Amplify only rebuilds on merges to `main`. A December build left untouched would
// still claim the old year all through January, so top the value up from the
// visitor's clock. The build-time year stays in the markup as the no-JS fallback.
const currentYear = new Date().getFullYear();

document.querySelectorAll("[data-current-year]").forEach((el) => {
    const buildYear = Number(el.textContent.trim());

    // Forward only. The visitor's clock is untrusted — a skewed one would otherwise
    // rewrite the notice backwards to "© 2019". Moving the year forward fixes the
    // stale build; moving it back could only ever be wrong.
    if (Number.isFinite(buildYear) && currentYear > buildYear) el.textContent = String(currentYear);
});
